<template>
    <div>
        <el-breadcrumb separator="/" class="bread">
            <el-breadcrumb-item :to="{ name: 'homePageManager' }">微页面管理</el-breadcrumb-item>
            <el-breadcrumb-item>新增微页面</el-breadcrumb-item>
        </el-breadcrumb>
        <div>
            <el-form  :model="pageForm" :rules="pagerules" ref="pageForm"
                      class="demo-ruleForm" :inline="true" >
                <el-form-item label="页面名称" prop="pageName">
                    <el-input v-model="pageForm.pageName" placeholder="页面名称" style="width: auto;"></el-input>
                </el-form-item>

                <el-form-item  label="机器编号" prop="kioskNo">
                    <el-select v-model="pageForm.kioskNo" placeholder="机器编号" @change="changeKioskNo()">
                        <el-option label="K1-A112" value="K1-A112" v-show="this.getcookie('storeId')=='store001'">K1-A112</el-option>
                        <el-option label="K1-A113" value="K1-A113" v-show="this.getcookie('storeId')=='store001'">K1-A113</el-option>
                        <el-option label="X2-A179" value="X2-A179" v-show="this.getcookie('storeId')=='0001'">X2-A179</el-option>
                        <el-option label="X2-A173" value="X2-A173" v-show="this.getcookie('storeId')=='0001'">X2-A173</el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <el-form :model="pageForm" :rules="pagerules" ref="pageForm"
                     class="demo-ruleForm">
                <el-form-item label="组件类型" prop="componentType">
                    <div>
                        <el-button type="primary" v-if="objinArrar({'type':'banner','name':'图片广告'},componentTypes)<0" @click="addComponent('banner')">图片广告</el-button>
                        <el-button type="primary"  @click="addComponent('notice')">通知栏</el-button>
                        <el-button type="primary"  @click="addComponent('specialOffer')">每日特价</el-button>
                        <el-button type="primary"  @click="addComponent('goodsGroup')">商品分组</el-button>
                    </div>
                </el-form-item>
                <div style="display: inline-block;width:52%;text-align: center;">
                    <div>预览</div>
                    <div  v-for="(item,index) in imgUrls">
                        <img style="width:360px;margin-left: 60px;" :src="item.imgUrl"/>
                        <el-button type="primary" @click="editorComponent(index)">编辑</el-button>
                        <el-button type="primary" @click="delComponent(index)">删除</el-button>
                    </div>
                </div>

                <el-form-item>
                    <el-button type="primary"  @click="submitForm('pageForm')"
                               id="primary">确 定</el-button>
                    <el-button @click="resetForm('pageForm')">重 置</el-button>
                </el-form-item>
            </el-form>

        </div>

        <div>
            <el-dialog :visible.sync="dialogVisible" :title="componentInfo.typeName" :modal="false" v-model="componentInfo">
                <div>
                    <el-form :model="componentForm" :rules="componentrules" ref="componentForm" class="demo-ruleForm">

                        <el-form-item label="素材资源" v-if="componentInfo.type=='banner'">
                            <el-select v-model="componentForm.sourceId" placeholder="资源">
                                <el-option v-for="(item,index) in resourcesList" :label="item.label" :value="item.value">{{item.label}}</el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="显示文本" v-if="componentInfo.type=='notice'">
                            <el-input v-model="componentForm.content" placeholder="文本" style="width: auto;"></el-input>
                        </el-form-item>

                        <el-form-item label="背景颜色" v-if="componentInfo.type=='notice'">
                            <el-input v-model="componentForm.bgColor" placeholder="背景颜色" style="width: auto;"></el-input>
                        </el-form-item>

                        <el-form-item label="字体颜色" v-if="componentInfo.type=='notice'">
                            <el-input v-model="componentForm.color" placeholder="字体颜色" style="width: auto;"></el-input>
                        </el-form-item>

                        <el-form-item label="跳转目标" v-if="componentInfo.type=='banner'">
                            <el-select v-model="componentForm.targetType" placeholder="跳转目标类型">
                                <el-option v-for="(item,index) in targetTypeList" :label="item.label" :value="item.value">{{item.label}}</el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="跳转链接" v-if="componentInfo.type=='banner'&&componentForm.targetType=='web'">
                            <el-input v-model="componentForm.targetUrl" placeholder="跳转链接" style="width: auto;"></el-input>
                        </el-form-item>

                        <el-form-item label="商品信息" v-if="componentInfo.type=='banner'&&componentForm.targetType=='goods'">
                            <el-select v-model="componentForm.targetUrl" placeholder="商品信息">
                                <el-option v-for="(item,index) in productList" :label="item.productName" :value="item.productId">{{item.productName}}</el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="特价活动" v-if="componentInfo.type=='specialOffer'||(componentInfo.type=='banner'&&componentForm.targetType=='activity')">
                            <el-select v-model="componentForm.targetUrl" placeholder="特价活动">
                                <el-option v-for="(item,index) in specActList" :label="item.act_name" :value="item.act_id">{{item.act_name}}</el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="显示数量" v-if="componentInfo.type=='goodsGroup'">
                            <el-select v-model="componentForm.layoutType" placeholder="显示数量">
                                <el-option label="每行2个" value="0">每行2个</el-option>
                                <el-option label="每行3个" value="1">每行3个</el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="商品分组" v-if="componentInfo.type=='goodsGroup'||(componentInfo.type=='banner'&&componentForm.targetType=='goodsGroup')">
                            <el-select v-model="componentForm.targetUrl" placeholder="商品分组">
                                <el-option v-for="(item,index) in goodsGroupList" :label="item.groupName" :value="item.groupId">{{item.groupName}}</el-option>
                            </el-select>
                        </el-form-item>

                    </el-form>
                </div>

                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="saveComponentInfo()">确定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
    import moment  from 'moment'
//    import { product, productUpdate, categoryProduct } from '@/assets/api.js'
    export  default{
        data(){
            return{
                url:this.homePageHost+this.saveHomePageUrl,
                groupUrl:this.productURL+"/vueFeign/findGroup",
                //uploadurl:this.requetHost+"/exManager/UplodExlFile",
                pushURL: this.productURL+"/vueFeign/getProductPutaway",
                dialogVisible:false,
                isorno:true,
                isShow:false,
                isexpSecond:false,
                isorgsubmit:false,
                resourceType:"",
                labelposition:"left",
                prodindex:0,
                productList:[],
                imgUrls:[],
                componentInfo:{},
                specActList:[],
                goodsGroupList:[],
                resourcesList:[
                    {"label":"默认图片1","value":"0001"},{"label":"默认图片2","value":"0002"}
                ],
                targetTypeList:[
                    {"label":"外部页面","value":"web"},
                    {"label":"商品详情","value":"goods"},
                    {"label":"商品分组","value":"goodsGroup"},
                    {"label":"特价活动","value":"activity"}
                ],
                componentInfos:[],
                componentTypes:[],
                componentForm:{
                    index:-1,
                    typeId:'',
                    content:'',
                    bgColor:'',
                    color:'',
                    sortNo:0,
                    layoutType:'0',
                    sourceId:'',
                    targetType:'',
                    targetUrl:'',
                },
                pageForm:{
                    pageName:'',
                    kioskNo:''
                },
                token:'123123123123',
                products:[],
                isorginit:'1',
                componentrules:{

                },
                pagerules: {
                    pageName: [
                        { required: true, message: '请输入页面名称', trigger: 'blur' },
                        /*{ validator: validateactName, trigger: 'blur' },*/
                        { min: 1, max: 40, message: '长度在 1 到 40 个字符', trigger: 'blur' }
                    ],
                    kioskNo: [
                        { required: true, message: '请选择机器编号', trigger: 'change' }
                    ]
                }
            }
        },
        created(){
//            this.getProductList();
//            this.getGoodsGroup();
        },
        methods:{
            objinArrar(check,param){
                var isExisted = false;
                var index = -1;
                for(var i=0;i<param.length;i++){
                    if (param[i].id == check.id) {
                        isExisted = true;
                        index = i;
                        return i;
                    }
                }
                if (!isExisted) {
                    console.log ("choose error");
                    return -1;
                }else{
                    return index;
                }
            },
            addComponent(componentType){
                if(componentType=='banner'){
                    var img={"imgUrl":this.homePageHost+'/sharefile/vue/homePage/banner.png'};
                    this.componentTypes.push({"type":componentType,"name":"图片广告"});
                    this.imgUrls.push(img);
                }else if(componentType=='notice'){
                    var img={"imgUrl":this.homePageHost+'/sharefile/vue/homePage/notice.png'};
                    this.imgUrls.push(img);
                    this.componentTypes.push({"type":componentType,"name":"通知栏"});
                }else if(componentType=='specialOffer'){
                    var img={"imgUrl":this.homePageHost+'/sharefile/vue/homePage/specialOffer.png'};
                    this.imgUrls.push(img);
                    this.componentTypes.push({"type":componentType,"name":"每日特价"});
                }else if(componentType=='goodsGroup') {
                    var img = {"imgUrl": this.homePageHost+'/sharefile/vue/homePage/goodsGroup.png'};
                    this.imgUrls.push(img);
                    this.componentTypes.push({"type":componentType,"name":"商品分组"});
                }
            },
            delComponent(index){
                this.imgUrls.splice(index, 1);
                this.componentTypes.splice(index, 1);
            },
            editorComponent(index){
                this.componentForm={
                index:-1,
                typeId:'',
                content:'',
                bgColor:'',
                color:'',
                sortNo:0,
                layoutType:'0',
                sourceId:'',
                targetType:'',
                targetUrl:'',
            };
                this.componentForm.index = index;
                this.componentInfo.type=this.componentTypes[index].type;
                this.componentInfo.typeName = this.componentTypes[index].name;
                this.componentForm.typeId=this.componentTypes[index].type;
                this.componentForm.sortNo = index;
                var flag = false;
                if(this.componentInfos.length>0){
                    for(var i=0;i<this.componentInfos.length;i++){
                        if(this.componentInfos[i].index==index){
                            flag =true;
                            this.componentForm = this.componentInfos[i];
                        }
                    }
                }
//                if(!flag){

//                }
                this.dialogVisible=true;
            },
            saveComponentInfo(){
                /*if(this.componentForm.typeId!='notice'){
                    if(this.componentForm.targetType!='web'){
                        this.componentForm.targetUrl=this.componentForm.targetType+","+this.componentForm.targetUrl;
                        this.componentForm.targetType='inside';
                    }
                }*/
                this.componentInfos.push(this.componentForm);
                this.dialogVisible=false;
            },
            delProductInfo(index){
                console.log(index);
                console.log("before1:"+this.pageForm.product[index]);
                console.log("before2:"+this.productList[index]);
                this.pageForm.product.splice(index, 1);
                this.productList.splice(index, 1);
                console.log("after1:"+this.pageForm.product[index]);
                console.log("after2:"+this.productList[index]);
            },
            changeKioskNo(){
              this.getGoodsGroup();
              this.getProductList();
              this.getActList();
            },
            getActList(){
                this.$http.get("https://antgine.paybay.cn/vueFeign/admin/activity/app/seckill/find/all?machineId="+this.pageForm.kioskNo)
                    .then(response => {
                        console.log(response.body)
                        if (response.body.Code === '200') {
                            this.specActList = response.body.Data.actList;
                        }
                    }, function (response) {
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });

                    })
            },
            getGoodsGroup(){
                var params = {kioskNo:this.pageForm.kioskNo,groupName:'',tenantId:this.getcookie('storeId')};
                //异步请求
                this.$http.post(this.groupUrl,params)
                    .then(response => {
                        if (response.status === 200) {
                            if(response.body.Code=='200'){
                                this.goodsGroupList = response.body.Data
                            }else if(response.body.code=='500'){
                                this.$message({ showClose: true, message: response.body.msg,  type: 'error' });
                            }
                        }
                        this.loading = false;
                    },function(response){
                        this.loading = false;
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
            },
            getProductList(){
                var params = {kioskNo:this.pageForm.kioskNo,tenantId:this.getcookie('storeId')};
                //异步请求
                this.$http.post(this.pushURL,params)
                    .then(response => {
                        if (response.status === 200) {
                            if(response.body.Code=='200'){
                                this.productList = response.body.Data.data
                                this.loading = false;
                            }else if(response.body.code=='500'){
                                this.$message({ showClose: true, message: response.body.msg,  type: 'error' });
                            }
                        }
                    },function(response){
                        this.loading = false;
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
            },
            in_array(str, array) {
                for (var s = 0; s < array.length; s++) {
                    var thisEntry = array[s].toString();
                    if (thisEntry == str) {
                        return true;
                    }
                }
                return false;
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    console.log("111");
                    /*if (valid) {
                        this.isorgsubmit = true;*/
                    var components = JSON.stringify(this.componentInfos);
                    console.log(components);
                    var params={pageName:this.pageForm.pageName,deviceId:this.pageForm.kioskNo,components:components,
                        tenantId:this.getcookie('storeId'),Token:this.token}
                    this.$http.post(this.url,params).then((response)=>{
                        var data=response.body;
                        if(data.Code=="200") {
                            this.$message({showClose: true, message: '保存成功', type: 'success'});
                            this.$router.push({path: "homePageManager"})
                        }else if(data.Code == "501202"||data.Code == "500"){
                            this.$message({showClose: true,message: data.Meta ,type: 'error'});
                        }else{
                            this.$message({showClose: true,message: '参数错误',type: 'error'});
                        }
                    },()=>{
                        this.$message({showClose: true,message: '网络异常',type: 'error'});
                    })

                    /*}else{
                        console.log('error submit!!');
                        return false
                    }*/
                });
            },
            getStartDate(vue){
                var d = new Date(vue);
                var formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
                this.pageForm.expDate=moment(d).format(formatString);
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            clear(name) {
                this.$refs[name].clearFiles();
            },
            export2Excel() {
                var codeList= [{name:'001',status:0},{name:'002',status:0},{name:'003',status:0}]
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../../../vendor/Export2Excel');
                    const tHeader = ['优惠券码','优惠券状态'];
                    const filterVal = ['name','status'];
                    const list = codeList;
                    const data = this.formatJson(filterVal, list);
                    export_json_to_excel(tHeader, data, '提货码列表');
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
        }
    }
</script>
<style>
    .isable{
        display:none;
    }
    .demo-ruleForm{

        margin: 30px auto 0 auto;
        text-align: left;
    }
</style>



// WEBPACK FOOTER //
// addHomePage.vue?5863be3a